import { render, staticRenderFns } from "./ButtonClose.vue?vue&type=template&id=757cb5fe&scoped=true"
import script from "./ButtonClose.vue?vue&type=script&lang=js"
export * from "./ButtonClose.vue?vue&type=script&lang=js"
import style0 from "./ButtonClose.vue?vue&type=style&index=0&id=757cb5fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757cb5fe",
  null
  
)

export default component.exports